import { create } from 'zustand';

interface ConnectionStore {
  wsConnected: boolean;
  isOnline: boolean;
  notificationCount: number;

  setWsConnected: (v: boolean) => void;
  setOnline: (v: boolean) => void;
  setNotificationCount: (n: number) => void;
  incrementNotifications: () => void;
  clearNotifications: () => void;
}

export const useConnectionStore = create<ConnectionStore>((set) => ({
  wsConnected: false,
  isOnline: typeof navigator !== 'undefined' && navigator.onLine !== undefined ? navigator.onLine : true,
  notificationCount: 0,

  setWsConnected: (v) => set({ wsConnected: v }),
  setOnline: (v) => set({ isOnline: v }),
  setNotificationCount: (n) => set({ notificationCount: n }),
  incrementNotifications: () => set((s) => ({ notificationCount: s.notificationCount + 1 })),
  clearNotifications: () => set({ notificationCount: 0 }),
}));

// Wire up browser online/offline events
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener('online', () => useConnectionStore.getState().setOnline(true));
  window.addEventListener('offline', () => useConnectionStore.getState().setOnline(false));
}
